import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading text-background-50">韩漫网</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              韩漫画免费阅读平台，提供韩漫全集大全，采用下拉式无广告阅读模式，随时随地畅享各种漫画内容。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-background-50"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">分类浏览</Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">恋爱漫画</Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">奇幻漫画</Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">动作漫画</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门推荐</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/comic/1" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">重生之女王归来</Link>
              </li>
              <li>
                <Link to="/comic/2" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">我在异世界当剑圣</Link>
              </li>
              <li>
                <Link to="/comic/7" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">花间词：宫廷秘史</Link>
              </li>
              <li>
                <Link to="/comic/11" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">无限重生：末日战神</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">品牌介绍</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">用户口碑</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">联系我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">隐私政策</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 韩漫网 HanManWang. 保留所有权利。
          </p>
          <p className="text-xs text-foreground-500">
            韩漫画免费 · 韩漫全集大全 · 漫画下拉式无广告
          </p>
        </div>
      </div>
    </footer>
  );
}